import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { dataLayerPush } from '@/helpers/dataLayer';
import clsx from 'clsx';
import Button from '../Button/Button';
function BackButton({ className, backIcon = 'arrow-left', backText, backUrl, additionalDataLayerProps, backButtonAriaLabel, }) {
    return (_jsx(Button, { mode: "interactive", variant: "text", icon: backIcon, className: clsx('relative z-10', className), children: ({ icon: buttonIcon, ...buttonProps }) => (_jsxs("a", { href: backUrl, onClick: () => dataLayerPush('ctaInteraction', {
                ...(additionalDataLayerProps || {}),
                click_text: backText,
                click_url: backUrl,
            }), ...buttonProps, "aria-label": backButtonAriaLabel || 'Back to previous page', "data-testid": "back-btn", children: [buttonIcon, " ", backText] })) }));
}
export default BackButton;
